import { unique } from '@cli-utils/shared.js'

export function parseIdList<TId extends string>(
  value: string | undefined,
  isId: (value: string) => value is TId,
  formatUnknownMessage: (ids: string[]) => string
): TId[] {
  if (!value) {
    return []
  }

  const ids = value
    .split(',')
    .map((entry) => entry.trim())
    .filter(Boolean)

  const invalid = ids.filter((id) => !isId(id))
  if (invalid.length > 0) {
    throw new Error(formatUnknownMessage(invalid))
  }

  return unique(ids as TId[])
}
